import { ILaundriesContext, ILaundriesState, LaundryStatus } from "./LaundriesProviderTypes";

export const LAUNDRIES_INITIAL_CONTEXT: ILaundriesContext = {
  laundries: {
    data: [],
    skip: 0,
    itemCount: 0,
    take: 10
  },
  query: {
    search: "",
    sortBy: "id",
    pageIndex: 1,
    pageSize: 10,
    isOpen: null
  },
  deleteLaundry: () => {},
  handleLaundriesPageChange: () => {},
  searchValue: "",
  handleSearchChange: () => {},
  handleStatusCheckboxClick: () => {},
  isOpenedChecked: false,
  isClosedChecked: false
}

export const LAUNDRIES_INITIAL_STATE: ILaundriesState = {
  laundries: {
    data: [],
    skip: 0,
    itemCount: 0,
    take: 10
  },
  searchValue: "",
  status: LaundryStatus.ALL,
  isOpenedChecked: false,
  isClosedChecked: false
}